import { apiRequest } from '../../../api/client';

/** Matches `apps/api` `SettingListItem` (`GET /settings`). */
export interface SettingListItem {
  key: string;
  value: unknown;
  category: string;
  description: string | null;
  isSystem: boolean;
  updatedAt: string;
}

export function listSettings(): Promise<SettingListItem[]> {
  return apiRequest<SettingListItem[]>('/settings');
}

/** Matches `apps/api` `UpdatedSettingView` (`PATCH /settings/:key`). */
export interface UpdatedSetting {
  key: string;
  value: unknown;
  updatedAt: string;
}

export function updateSetting(key: string, value: unknown): Promise<UpdatedSetting> {
  return apiRequest<UpdatedSetting>(`/settings/${encodeURIComponent(key)}`, {
    method: 'PATCH',
    body: JSON.stringify({ value }),
  });
}

/** Matches `apps/api` `SettingHistoryEntry` (`GET /settings/:key/history`). */
export interface SettingHistoryEntry {
  action: string;
  userId: string | null;
  userName: string | null;
  changes: unknown;
  createdAt: string;
}

export function getSettingHistory(key: string): Promise<SettingHistoryEntry[]> {
  return apiRequest<SettingHistoryEntry[]>(`/settings/${encodeURIComponent(key)}/history`);
}
